import React from "react";
import BorderedButton from "Components/Common/components/Button/BorderedButton"
import FillButton from "Components/Common/components/Button/FillButton"
import ModalBody from "Components/Common/Modal/ModalBody"
import ModalContainer from "Components/Common/Modal/ModalContainer"
import ModalHeader from "Components/Common/Modal/ModalHeader"

interface ConfirmationModalProps {
    title: string;
    message: string;
    showModal: boolean;
    closeModal: () => void;
    onConfirm: () => void;
    confirmationButtonText?: string;
    cancelButtonText?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ title, message, showModal, closeModal, onConfirm, confirmationButtonText, cancelButtonText }) => {
    return (<ModalContainer
        isOpen={showModal}
        setOpen={closeModal}
    >
        <ModalHeader>
            <div className=" tw-py-2">
                <h5 className="tw-text-l tw-font-bold">{title}</h5>
            </div>
        </ModalHeader>
        <ModalBody>
            <div className="tw-space-y-3 tw-py-4">
                <p className="tw-pb-4">{message}</p>
                <div className="tw-flex tw-justify-end tw-space-x-3">
                    <BorderedButton onClick={() => closeModal()}>{cancelButtonText ?? "Cancel"}</BorderedButton>
                    <FillButton
                        className={`!tw-border-red-500 !tw-bg-red-500 hover:!tw-bg-primary-hover hover:!tw-border-primary-hover`}
                        onClick={() => { onConfirm(); closeModal(); }}
                        disabledClassName="!tw-border-red-200 !tw-bg-red-200"
                    >{confirmationButtonText ?? "Confirm"}</FillButton>
                </div>
            </div>
        </ModalBody>
    </ModalContainer>)
}

export default ConfirmationModal